export const translations = {
  novoContato: {
    pt: 'Novo Contato',
    en: 'New Contact',
    de: 'Neuer Kontakt',
    es: 'Nuevo Contacto',
  },
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
};
